module.exports = __webpack_public_path__ + "media/images/ribbon_ug_icon-561d55d3f037f2cd1d83bc23350dd836.svg";